module.exports = __webpack_public_path__ + "static/media/ic_dropdown_white.0b860ce7.svg";